import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from 'src/styles/media';

import imgLogo from 'src/assets/images/618-logo-white.svg';
import imgRennie from 'src/assets/images/rennie-logo-white.png';
import imgSkyllen from 'src/assets/images/skyllen-logo.svg';
import imgFacebook from 'src/assets/images/facebook.svg';
import imgInstagram from 'src/assets/images/instagram.svg';

const Footer = () => (
  <Root>
    <Content>
      <img src={imgLogo} alt="618 Carnarvon" />
      <List>
        <h3>Neighbourhood</h3>
        <ul>
          <li>
            <Link to="/legacy">History</Link>
          </li>
          <li>
            <Link to="/neighbourhood">New Westminster</Link>
          </li>
        </ul>
      </List>
      <List>
        <h3>618 Carnarvon</h3>
        <ul>
          <li>
            <Link to="/building">The Building</Link>
          </li>
          <li>
            <Link to="/interiors">Interiors</Link>
          </li>
          <li>
            <Link to="/floorplans">Floorplans</Link>
          </li>
          <li>
            <Link to="/virtualtours">Virtual Tours</Link>
          </li>
          <li>
            <Link to="/views">Views</Link>
          </li>
          <li>
            <Link to="/team">Team</Link>
          </li>
        </ul>
      </List>
      {/* <List>
        <h3>Presentation Centre</h3>
        <ul>
          <a
            href="https://www.google.com/maps/place/618+Carnarvon+St,+New+Westminster,+BC+V3M+1E9/@49.2037656,-122.9115746,17z/data=!3m1!4b1!4m5!3m4!1s0x5485d95ba790fcd5:0xba4b1f4cc1ee77a6!8m2!3d49.2037621!4d-122.9093806"
            target="_blank"
            rel="noopener noreferrer"
          >
            <li>618 Carnarvon Street</li>
            <li>New Westminster, BC</li>
          </a>
          <li>Open 12-5pm daily except Fridays or by appointment only</li>
        </ul>
      </List> */}
      <List>
        <h3>Contact</h3>
        <ul>
          <li>
            <a
              href="mailto:info@618carnarvon.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              info@618carnarvon.com
            </a>
          </li>
          <li>778-397-8999</li>
          <li>
            <Social
              href="https://www.facebook.com/skyllenpacific/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imgFacebook} alt="Facebook" />
            </Social>
            <Social
              href="https://www.instagram.com/skyllenpacific/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imgInstagram} alt="Instagram" />
            </Social>
          </li>
        </ul>
      </List>
    </Content>
    <Logos>
      <a
        href="https://www.skyllenpacific.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={imgSkyllen} alt="Skyllen Pacific" />
      </a>
      <Rennie
        href="https://rennie.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={imgRennie} alt="Rennie" />
      </Rennie>
    </Logos>
    <Disclaimer>
      <div />
      <p>
        This is not an offering for sale. Any such offering can only be made
        with a disclosure statement. Prices are subject to change without
        notice. Artist’s renderings and maps are representations only and may
        not be accurate. E&amp;O.E.
      </p>
    </Disclaimer>
  </Root>
);

export default Footer;

const Root = styled.div`
  background-color: ${({ theme }) => theme.colorDarkBlue};
  font-family: ${({ theme }) => theme.fontHeader};
  padding: 40px 30px;
  @media (min-width: ${media.smup}) {
    padding: 40px 60px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${media.smup}) {
    flex-direction: row;
  }
  img {
    width: 50%;
    align-self: flex-start;
    margin-bottom: 10px;
    @media (min-width: ${media.smup}) {
      width: 10%;
      margin-bottom: 0;
    }
    @media (min-width: ${media.mdup}) {
      margin-right: 5%;
    }
  }
`;

const Rennie = styled.a`
  img {
    margin-left: -48px;
    width: 200px;
    height: 50px;
    object-fit: cover;
    @media (min-width: ${media.smup}) {
      margin-left: 0;
      margin-right: -45px;
    }
  }
`;

const Social = styled.a`
  img {
    margin-right: 10px;
    max-width: 20px;
    max-height: 20px;
  }
`;

const Logos = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media (min-width: ${media.smup}) {
    justify-content: flex-end;
    flex-direction: row;
    align-items: flex-start;
  }
  a {
    @media (min-width: ${media.smup}) {
      margin-left: 60px;
    }
  }
`;

const Disclaimer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 50px;
  @media (min-width: ${media.smup}) {
    justify-content: space-between;
  }
  p {
    width: 100%;
    color: white;
    font-size: 12px;
    text-align: left;
    @media (min-width: ${media.smup}) {
      width: 50%;
      text-align: right;
    }
  }
  div {
    width: 100%;
    text-align: left;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    @media (min-width: ${media.smup}) {
      flex-direction: row;
      width: 30%;
      text-align: left;
      margin: 0;
    }
    a {
      margin-right: 20px;
      margin-bottom: 15px;
    }
  }
`;

const List = styled.div`
  width: 100%;
  text-align: left;
  margin: 10px 0;
  @media (min-width: ${media.smup}) {
    width: 18%;
    margin-left: 3%;
    text-align: left;
  }
  @media (min-width: ${media.mdup}) {
    width: 15%;
  }
  h3 {
    color: white;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 10px;
  }
  li {
    list-style-type: none;
    color: ${({ theme }) => theme.colorPrimary};
    text-transform: uppercase;
    margin-bottom: 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Footer.js